import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Eye: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6667 7.73332C14.6667 8.85332 11.6821 12.8 7.99999 12.8C4.31786 12.8 1.33333 8.85332 1.33333 7.73332C1.33333 6.61332 4.31786 2.66666 7.99999 2.66666C11.6821 2.66666 14.6667 6.61332 14.6667 7.73332Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 9.86667C9.36534 9.86667 10.1333 9.09867 10.1333 7.73334C10.1333 6.36801 9.36534 5.60001 8 5.60001C6.63467 5.60001 5.86667 6.36801 5.86667 7.73334C5.86667 9.09867 6.63467 9.86667 8 9.86667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
